import { useAuth0User } from '@/app/modules/Context/useAuth0User';
import { DynamicPageData, DynamicPageType } from '@/types/cms';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import { NextSeo } from 'next-seo';
import React from 'react';
import { getDynamicPageData } from 'utils/getDynamicPageData';

import { CmsModuleList } from 'components/CMS/CmsModuleList';

import JobSearchBox from 'modules/JobSearchBox';
import { ContainerStyle, UserLoggedinContainer } from 'modules/UserLoggedinContainer';

import styles from './style.module.scss';

const default_description = 'Discover the right doctor job for you in Australia or New Zealand';

const Jobs = ({ data, pageData }: DynamicPageData) => {
  const { user } = useAuth0User();
  return (
    <>
      <NextSeo
        title={pageData.meta_title || 'Doctor Job Search'}
        description={pageData.meta_description || default_description}
        openGraph={{
          title: pageData.meta_title || 'Doctor Job Search',
          description: pageData.meta_description || default_description,
        }}
      />
      <UserLoggedinContainer size={'md'} style={ContainerStyle.SMALL_BLUE_BANNER}>
        <h1 className={styles.pageHeadingCentered}>{default_description}</h1>

        <JobSearchBox />

        {!user && (
          <p className={styles.noLoingNotice}>
            Receive job alerts straight to your email inbox by saving your search.
          </p>
        )}
        <div>
          <CmsModuleList modules={data} />
        </div>
      </UserLoggedinContainer>
    </>
  );
};

export async function getServerSideProps(
  context: GetServerSidePropsContext,
): Promise<GetServerSidePropsResult<DynamicPageData>> {
  const {
    modules = [],
    pageData,
    error,
  } = await getDynamicPageData(DynamicPageType.Job_Searching_Page, context);

  if (error) {
    return { notFound: true };
  }

  return {
    props: {
      data: modules,
      pageData,
    },
  };
}

export default Jobs;
